/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types rule when this issue https://github.com/asbjornh/view-models/issues/18 is resolved
import React, { useMemo } from 'react';
import ButtonBase from 'components/models/button-base';
import Icon from 'components/icon';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ariaAttributesModel from 'components/models/aria-attributes/aria-attributes';

// eslint-disable-next-line view-models/no-errors
export const themes = {
  light: 'light',
  outline: 'outline',
};

// eslint-disable-next-line view-models/no-errors
export const types = {
  regular: 'regular',
  external: 'external',
  restricted: 'restricted',
  download: 'download',
};

// eslint-disable-next-line view-models/no-errors
export const actionTypes = {
  close: 'close',
  menu: 'menu',
};

export const mapButtonTypeToIconName = type => {
  switch (type) {
    case types.external:
      return 'external';
    case types.restricted:
      return 'lock';
    case types.download:
      return 'download';
    case types.regular:
    default:
      return 'arrow-right';
  }
};

const mapActionTypeToIconName = actionType => {
  switch (actionType) {
    case actionTypes.close:
      return 'close';
    case actionTypes.menu:
      return 'menu';
    default:
      return null;
  }
};

const LinkButton = ({
  className,
  openInNewTab = false,
  url,
  text,
  tabindex,
  type,
  action,
  hideIcon = false,
  theme = themes.light,
  onClick,
  ariaAttributes = {},
}) => {
  const RootTag = url ? 'a' : 'button';

  const iconName = useMemo(() => mapButtonTypeToIconName(type), [type]);
  const actionIconName = useMemo(
    () => mapActionTypeToIconName(action),
    [action]
  );

  return (
    <RootTag
      href={url}
      className={cn('link-button', {
        [`link-button_theme-${theme}`]: theme,
        [className]: className,
      })}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'nofollow noopener' : null}
      tabIndex={tabindex}
      {...(type === types.download && {
        download: 'download',
      })}
      onClick={onClick}
      {...ariaAttributes}
    >
      <span className="link-button__text">{text}</span>
      {!hideIcon && actionIconName && (
        <span className="link-button__icon-holder">
          <Icon name={actionIconName} className="link-button__icon" />
        </span>
      )}
      {!hideIcon && iconName && !actionIconName && (
        <span className="link-button__icon-holder">
          <Icon name={iconName} className="link-button__icon" />
        </span>
      )}
    </RootTag>
  );
};
LinkButton.viewModelMeta = 'ignore';

LinkButton.propTypes = Object.assign({}, ButtonBase.propTypes, {
  className: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(themes)),
  type: PropTypes.oneOf(Object.values(types)),
  action: PropTypes.oneOf(Object.values(actionTypes)),
  ariaAttributes: PropTypes.exact(ariaAttributesModel),
});

export default LinkButton;
